import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/tmp/build_3fef09c4/src/layouts/default.vue").then(m => m.default || m))
}